import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import cn from 'classnames';
import { MONTHS, TP } from '../../constants/consts';
import FormikAutocompleteSelect from './FormikAutocompleteSelect';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    maxWidth: 400,
    minWidth: 350,
    position: 'relative',
    marginBottom: theme.spacing(2),
  },
  errorMessage: {
    position: 'absolute',
    width: 400,
  },
}));

const DateField = ({ dateFields, minYear, maxYear, className }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const days = Array.from({ length: 31 }, (_, i) => ({ value: i + 1, label: i + 1 }));
  const months = MONTHS.map((m, i) => ({ value: i + 1, label: t(m) }));
  const getYearsOptions = () => {
    const arrLength = maxYear - minYear;
    return Array.from({ length: arrLength }, (v, i) => {
      const currValue = maxYear - arrLength + i + 1;
      return { value: currValue, label: currValue };
    });
  };
  const years = getYearsOptions();

  const commonProps = {
    component: FormikAutocompleteSelect,
    t: { t },
    isClearable: true,
    withFiltering: true,
  };

  return (
    <div className={cn(classes.container, className)}>
      <Field
        name={dateFields.day.name}
        instanceId={dateFields.day.name}
        label={t(`${TP}.m_DAY`)}
        options={days}
        errorMessageClass={classes.errorMessage}
        {...commonProps}
      />
      <Field
        name={dateFields.month.name}
        instanceId={dateFields.month.name}
        label={t(`${TP}.m_MONTH`)}
        options={months}
        {...commonProps}
      />
      <Field
        name={dateFields.year.name}
        instanceId={dateFields.year.name}
        label={t(`${TP}.m_YEAR`)}
        options={years}
        {...commonProps}
      />
    </div>
  );
};

DateField.propTypes = {
  dateFields: PropTypes.shape({
    day: PropTypes.object,
    month: PropTypes.object,
    year: PropTypes.object,
  }),
  minYear: PropTypes.number,
  maxYear: PropTypes.number,
  className: PropTypes.string,
};

DateField.defaultProps = {};

export default DateField;
